export default "__VITE_ASSET__8NDuGKKr__"